import React from "react";
import { Card, Heading } from "uikit/components";
import styles from "./BuildingLoadingEventsView.module.styl";
import { arrayOf, number, shape, string } from "prop-types";
import BuildingLoadingEventRow from "../BuildingLoadingEventRow/BuildingLoadingEventRow";
import BuildingLoadingEventMobile from "../BuildingLoadingEventMobile/BuildingLoadingEventMobile";

export default function BuildingLoadingEventsView({ eventsData }) {
    return (
        <>
            <Heading size={"h2"} className={styles.heading} name="building-loading-events-header">
                Мероприятия, запланированные на объекте
            </Heading>
            <>
                <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
                    <div className={styles.headingContainer}>
                        <div>Название мероприятия</div>
                        <div>Вид спорта</div>
                        <div>Вид мероприятия</div>
                        <div>Статус мероприятия</div>
                        <div>Дата начала</div>
                        <div>Дата завершения</div>
                    </div>
                    <div data-test-name="events_in_object">
                        {eventsData?.map((item) => (
                            <BuildingLoadingEventRow key={item.id} eventData={item} />
                        )) ?? []}
                    </div>
                </Card>

                <div className={styles.mobileForm}>
                    {eventsData?.map((item) => (
                        <BuildingLoadingEventMobile key={item.id} eventData={item} />
                    ))}
                </div>
            </>
        </>
    );
}

BuildingLoadingEventsView.propTypes = {
    eventsData: arrayOf(
        shape({
            id: number.isRequired,
            name: string.isRequired,
            dateInterval: shape({
                start: string.isRequired,
                end: string.isRequired,
            }).isRequired,
            eventStatus: string.isRequired,
            eventType: string.isRequired,
            sportType: string.isRequired,
            locationName: string.isRequired,
        }),
    ),
};
